import React from "react";

export default function AIScoreCard({ score = {} }) {
  const items = [
    { label: "Opportunity", value: score.opportunity, color: "#d4a574" },
    { label: "Investment", value: score.investment_potential, color: "#7c9a85" },
    { label: "Growth", value: score.growth_potential, color: "#60a5fa" },
    { label: "Acquisition", value: score.acquisition_potential, color: "#c084fc" },
  ].filter(i => i.value != null);

  const riskColors = { low: "#34d399", medium: "#fbbf24", high: "#f87171" };

  return (
    <div className="border border-[#33291f] rounded-lg bg-gradient-to-br from-[#1c1712] to-[#14100c] p-5" data-testid="ai-score-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="w-1.5 h-1.5 rounded-full bg-[#d4a574] pin-pulse" style={{ color: "#d4a574" }} />
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#d4a574] font-semibold">AI Analysis</div>
        </div>
        <span className="text-[10px] px-2 py-0.5 rounded border border-[#4a3a2b] text-[#7a6d5a] uppercase tracking-wider">Estimate</span>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-5">
        {items.map((it) => (
          <div key={it.label}>
            <div className="text-[10px] uppercase tracking-wider text-[#7a6d5a] mb-1">{it.label}</div>
            <div className="flex items-baseline gap-1.5">
              <span className="font-display text-[26px] font-bold" style={{ color: it.color }}>{Math.round(it.value)}</span>
              <span className="text-[10px] text-[#7a6d5a]">/100</span>
            </div>
            <div className="mt-1 h-1 bg-[#241d16] rounded overflow-hidden">
              <div className="h-full rounded" style={{ width: `${Math.min(100, it.value)}%`, backgroundColor: it.color }} />
            </div>
          </div>
        ))}
      </div>
      {score.risk_level && (
        <div className="flex items-center gap-2 mb-3 text-[11px]">
          <span className="text-[#7a6d5a] uppercase tracking-wider">Risk:</span>
          <span className="uppercase tracking-wider font-semibold" style={{ color: riskColors[score.risk_level] }}>{score.risk_level}</span>
        </div>
      )}
      {score.reasoning && (
        <div className="text-[12.5px] text-[#b8ac96] leading-relaxed italic border-l-2 border-[#4a3a2b] pl-3">
          "{score.reasoning}"
        </div>
      )}
      <div className="text-[9px] text-[#7a6d5a] mt-3 font-mono uppercase tracking-wider">
        AI-Generated Assessment · Not investment advice
      </div>
    </div>
  );
}
